import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select",
  "use": "icon-select-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-select\"><defs><style type=\"text/css\"></style></defs><path d=\"M852.4 2H172.1C78.2 2 2.3 78 2.3 171.8v679.8c0 94.3 76 170.3 169.8 170.3h679.8c93.8 0 169.8-76 169.8-169.8V171.8C1022.3 78 946.3 2 852.4 2zM481.7 737.9L206.3 462.5l47.4-47.4 228 228 322.8-322.8 47.4 47.4-370.2 370.2z\" fill=\"#3C8EDE\" p-id=\"2616\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol